// CasaRosa Product Page Trust Strip — Sprint 2c (2026-05-15)
// Injects locale-aware trust signals below product price on product pages.
// Selector fallback chain handles Foxify + Dawn DOM variants.
// Idempotent via data-casarosa-trust guard.
(function () {
  'use strict';
  if (!document.body || !document.body.classList.contains('template-product')) return;

  var lang = (document.documentElement.lang || 'en').toLowerCase();
  var locale = lang.indexOf('fr') === 0 ? 'fr' : lang.indexOf('ar') === 0 ? 'ar' : 'en';
  var copy = {
    en: { d: 'Free delivery on orders over 300 Dhs', c: 'Pay on delivery — no advance payment', w: 'Need help? Message us on WhatsApp' },
    fr: { d: 'Livraison gratuite à partir de 300 Dhs', c: 'Paiement à la livraison — aucune avance', w: "Besoin d'aide ? Contactez-nous sur WhatsApp" },
    ar: { d: 'توصيل مجاني للطلبات فوق 300 درهم', c: 'الدفع عند الاستلام — بدون دفع مسبق', w: 'تحتاج مساعدة؟ راسلنا على واتساب' }
  };
  var t = copy[locale];

  if (!document.getElementById('casarosa-trust-strip-style')) {
    var style = document.createElement('style');
    style.id = 'casarosa-trust-strip-style';
    style.textContent = '.casarosa-trust-strip{display:flex;flex-direction:column;gap:10px;margin:18px 0;padding:14px 16px;background:rgba(248,175,166,0.12);border:1px solid rgba(248,175,166,0.45);border-radius:12px;font-family:inherit}.casarosa-trust-strip__item{display:flex;align-items:center;gap:12px;font-size:14px;line-height:1.4;color:#0C0D0D}.casarosa-trust-strip__icon{flex-shrink:0;width:28px;height:28px;display:flex;align-items:center;justify-content:center;font-size:16px;background:#fff;border-radius:50%;box-shadow:0 1px 2px rgba(0,0,0,0.05)}.casarosa-trust-strip__label{font-weight:500;flex:1}html[dir="rtl"] .casarosa-trust-strip__item{flex-direction:row-reverse;text-align:right}@media (min-width:750px){.casarosa-trust-strip{margin:22px 0;padding:16px 18px}.casarosa-trust-strip__item{font-size:15px}}';
    document.head.appendChild(style);
  }

  function build() {
    var s = document.createElement('div');
    s.className = 'casarosa-trust-strip';
    s.setAttribute('data-casarosa-trust', '1');
    s.innerHTML =
      '<div class="casarosa-trust-strip__item"><span class="casarosa-trust-strip__icon">🚚</span><span class="casarosa-trust-strip__label">' + t.d + '</span></div>' +
      '<div class="casarosa-trust-strip__item"><span class="casarosa-trust-strip__icon">💵</span><span class="casarosa-trust-strip__label">' + t.c + '</span></div>' +
      '<div class="casarosa-trust-strip__item"><span class="casarosa-trust-strip__icon">💬</span><span class="casarosa-trust-strip__label">' + t.w + '</span></div>';
    return s;
  }

  function inject() {
    if (document.querySelector('[data-casarosa-trust]')) return true;
    var sels = ['.product-form__buttons', '.product__form', '.product-form', '[data-add-to-cart]', '.foxify-product-form', '.product__info .price__container', '.product__price', '.price'];
    for (var i = 0; i < sels.length; i++) {
      var el = document.querySelector(sels[i]);
      if (el) {
        var strip = build();
        if (/form|add-to-cart/.test(sels[i])) el.parentNode.insertBefore(strip, el);
        else el.parentNode.insertBefore(strip, el.nextSibling);
        return true;
      }
    }
    return false;
  }

  function init() {
    if (inject()) return;
    var n = 0;
    var iv = setInterval(function () { if (inject() || ++n >= 5) clearInterval(iv); }, 500);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
